import useHistoryTab from './hooks';
import styles from './HistoryTab.module.scss';

const HistoryTab = () => {
  const historyInfo = useHistoryTab();

  const renderHistoryInfo = () => (
    <div>
      <pre>{historyInfo}</pre>
    </div>
  );

  return <div className={styles.historyTab}>{renderHistoryInfo()}</div>;
};

export default HistoryTab;
